import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local/index';

const getSavedLang = (): 'ko' | 'en' => {
  try {
    const stored = window.localStorage.getItem('site_language');
    if (stored === 'en' || stored === 'ko') return stored as 'ko' | 'en';
  } catch { /* localStorage unavailable */ }
  return 'ko';
};

const initialLang = getSavedLang();

i18n.use(initReactI18next).init({
  lng: initialLang,
  fallbackLng: 'ko',
  supportedLngs: ['ko', 'en'],
  resources: messages,
  interpolation: { escapeValue: false },
});

export default i18n;